export { default as ContentfulResponsiveVideo } from "./ContentfulResponsiveVideo";
